import { render, staticRenderFns } from "./LearningCenterBlockModal.vue?vue&type=template&id=62b49a0c&"
import script from "./LearningCenterBlockModal.vue?vue&type=script&lang=js&"
export * from "./LearningCenterBlockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports